<template>
  <van-popup
    v-model="show"
    class="avtPopup"
    @close="closeMask"
  >
    <div class="top">
      <div
        v-for="(item, index) in list"
        :key="index"
        :class="`title_item ${active === index ? 'active' : ''}`"
        @click="change(index)"
      >
        <!-- <mail class="icon" /> -->
        <!-- <div class="title">
          {{ item.title }}
        </div> -->
      </div>
    </div>
    <div class="bottom">
      <!-- <van-icon
        class="left arrow"
        name="arrow-left"
        @click="handleArrow('left')"
      />
      <van-icon
        class="right arrow"
        name="arrow"
        @click="handleArrow('right')"
      /> -->
      <img
        :src="getImagePath(list[active].title)"
        alt=""
        class="pic"
      >
    </div>
    <div class="checkBox">
      <van-checkbox
        v-model="checked"
        shape="square"
        class="check"
        :icon-size="14"
      >
        Não mostrar novamente hoje
      </van-checkbox>
    </div>
    <div
      class="close_box"
      @click="closeMask"
    >
      <img
        src="../assets/images/common/close.png"
        class="close"
      >
    </div>
  </van-popup>
</template>
<script>
import mail from './svg/mail.vue'

const storageName = 'HOME_SHOW_MODAL'
export default {
    components: {
        mail
    },
    data() {
        return {
            show: false,
            checked: false,
            active: 0,
            list: [
                {
                    title: 'Autorizar',
                    img: 'https://pub-5c70fe8cd90541b985bb95404b6d5dde.r2.dev/image/2025/03/19/6eb12a1e74d8496f97cf4cf7048c75e8.png'
                },
                // {
                //     title: 'Atividade de primeiro depósito',
                //     img: 'https://front-o1.jingdd.xyz/202502/8f7e349e-b391-449a-a877-f0d6a9cf8d08.jpg'
                // },
                // {
                //     title: 'Agente nacional',
                //     img: 'https://front-o1.jingdd.xyz/202502/6676ed08-6e3d-48fb-b21e-d695868c9f24.jpg'
                // },
            ]
        }
    },
    watch: {
        show(newval) {
            if (!newval) {
                this.setLocalStorage()
            }
        }
    },
    mounted() {
        const data = localStorage.getItem(storageName)
        if (!data || data && !JSON.parse(data).value || new Date(JSON.parse(data).date).getDate() !== new Date().getDate()) {
            this.show = true
        }
    },
    methods: {
        change(e) {
            this.active = e
        },
        getImagePath(v) {
            if (v == 'Autorizar') {
                return require(`@/assets/images/act/po1.jpg`);
            } else if (v == 'Atividade de primeiro depósito') {
                return require(`@/assets/images/act/1.png`);
            } else {
                return require(`@/assets/images/act/2.png`);
            }
        },
        handleArrow(type) {
            const length = this.list.length
            if (type === 'left' && this.active > 0) {
                this.active -= 1
            } else if (type === 'left' && this.active === 0) {
                this.active = length - 1
            } else if (type === 'right' && this.active < length - 1) {
                this.active += 1
            } else if (type === 'right' && this.active === length - 1) {
                this.active = 0
            }
        },
        setLocalStorage() {
            const data = {
                value: this.checked,
                date: new Date().getTime()
            }
            localStorage.setItem(storageName, JSON.stringify(data))
        },
        closeMask() {
            this.$emit('close')
            this.show = false
        }
    }
}
</script>
<style scoped lang="less">
@import "../assets/css/variables.less";

.avtPopup {
    width: 90%;
    max-width: 375px;
    background-color: transparent;
}

.top {
    background-color: @secondary-color;
    display: flex;
    align-items: center;
    // padding: 4px;
    border-radius: 12px 12px 0 0;
}

.title_item {
    width: 24%;
    margin-right: 1%;
    display: flex;
    align-items: center;
    color: fade(@popupTextColor, 50%);

    &.active {
        color: @popupTextColor;

        .icon {
            color: @popupTextColor;
        }
    }

    .title {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        flex: 1;
        font-size: 11px;
    }

    .icon {
        color: fade(@popupTextColor, 50%);
        margin-right: 6px;
        width: 14px;
        height: 14px;
    }
}

.bottom {
    position: relative;

    .arrow {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        background-color: rgba(0, 0, 0, 0.3);
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 50%;
        color: #fff;

        &.right {
            right: 2%;
        }

        &.left {
            left: 2%;
        }
    }
}

.pic {
    width: 100%;
    height: 365px;
    border-radius: 0 0 12px 12px;
}

.checkBox {
    padding: 10px;
    display: flex;
    justify-content: center;

    .check {
        padding: 6px 10px;
        background-color: rgba(0, 0, 0, 0.2);

        :deep(.van-checkbox__label) {
            color: #fff;
        }

        :deep(.van-icon-success) {
            background-color: transparent !important;
        }

        :deep(.van-checkbox__icon--checked) {
            background-color: #04BE02 !important;
        }
    }
}
.close_box {
    .close {
        width: 20px;
        height: 20px;
        margin: 10px auto;
        display: block;
    }
}

</style>